module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/fulfillment.release/~/core-js/modules/_function-to-string.js
// module id = ../../../../core-js/modules/_function-to-string.js
// module chunks = 1